import React, { FC } from 'react';

import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRefinementList } from 'react-instantsearch-hooks-web';

import { DEFAULT_DISCOVER_URL } from '../../../../const';
import { CategoryNavigation } from '../CategoryNavigation';

interface ExpertNavigationBlockProps {
  attribute: string;
}

const ExpertNavigationBlock: FC<ExpertNavigationBlockProps> = ({ attribute }) => {
  const { t } = useTranslation();

  useRefinementList({ attribute });

  return (
    <Box>
      <CategoryNavigation
        link={`${DEFAULT_DISCOVER_URL}/experts`}
        title={t('page.discover.backToExperts')}
      />
    </Box>
  );
};

export default ExpertNavigationBlock;
